/**
 * GPS设备相关请求
 */
import request from "@/utils/request";

export interface GpsDeviceListRequestParams {
  page: number;
  limit: number;
  deviceId?: string;
  plateNumber?: string;
  onlineFlag?: number;
  goLiveFlag?: number;
  sort?: boolean;
  export?: boolean;
}

// 获取GPS设备列表
export const gpsDeviceListRequestPath = '/api/v2/gpsDevice/list';
export const gpsDeviceListRequest = (params: GpsDeviceListRequestParams) => {
  return request.post(gpsDeviceListRequestPath, params)
}

export interface GpsDeviceAddRequestParams {
  deviceId?: string;
  manufacturer?: string;
  plateNumber?: string;
}

// 新增GPS设备
export const gpsDeviceAddRequest = (data: GpsDeviceAddRequestParams) => {
  return request.post('/api/v2/gpsDevice/add', data)
}

export interface GpsDeviceEditRequestParams {
  id?: number;
  deviceId?: string;
  manufacturer?: string;
  plateNumber?: string;
}

// 编辑GPS设备
export const gpsDeviceEditRequest = (data: GpsDeviceEditRequestParams) => {
  return request.post('/api/v2/gpsDevice/edit', data)
}

// 删除GPS设备
export const gpsDeviceDeleteRequest = (id: number) => {
  return request.post(`/api/v2/gpsDevice/delete/${id}`)
}

export interface GpsDeviceExceptionListRequestParams {
  page: number;
  limit: number;
  day?: string;
  plateNumber?: string;
  deviceId?: string;
  faultDeviceTypeName?: string;
  billingModeName?: string;
  sort?: boolean;
  export?: boolean;
}

// 获取GPS设备异常列表
export const gpsDeviceExceptionListRequestPath = '/api/v2/gpsDevice/exceptionList';
export const gpsDeviceExceptionListRequest = (params: GpsDeviceExceptionListRequestParams) => {
  return request.post(gpsDeviceExceptionListRequestPath, params)
}
